import { OverlayView } from '@react-google-maps/api';
import { centroid } from '@turf/turf';

import { latLngArrayToGeoJSON } from '@domains/turf/utils/latLngArrayToGeoJSON';

interface PolygonIdLabelProps {
  id: string | number;
  path: google.maps.LatLngLiteral[];
  color?: string;
}

const baseStyle: React.CSSProperties = {
  background: 'rgba(255, 255, 255, 0.9)',
  borderRadius: 6,
  padding: '2px 8px',
  fontSize: 14,
  fontWeight: 700,
  lineHeight: 1.2,
  // El contenedor de OverlayView puede colapsar el ancho y hacer que el id se
  // parta ("2 2 1"). inline-block + width:max-content fuerzan a que la etiqueta
  // mida exactamente lo que ocupa el texto en una sola línea.
  display: 'inline-block',
  width: 'max-content',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  transform: 'translate(-50%, -50%)',
  pointerEvents: 'none',
  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
};

const getPolygonCenter = (
  path: google.maps.LatLngLiteral[]
): google.maps.LatLngLiteral | null => {
  if (!path || path.length === 0) return null;
  try {
    const feature = latLngArrayToGeoJSON(path);
    const center = centroid(feature);
    const [lng, lat] = center.geometry.coordinates;
    return { lat, lng };
  } catch {
    return null;
  }
};

export const PolygonIdLabel = ({
  id,
  path,
  color = '#0d6efd',
}: PolygonIdLabelProps) => {
  const center = getPolygonCenter(path);
  if (!center) return null;

  return (
    <OverlayView
      position={center}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
    >
      <div style={{ ...baseStyle, color, border: `1px solid ${color}` }}>
        {id}
      </div>
    </OverlayView>
  );
};
